import { PolicyApRulesResp } from './policy-ap-rules-resp.model';
import { PolicyPaymentsResp } from './policy-payments-resp.model';

export interface PolicySummary {
	id: string;
	contract: string;
	name: string;
}

export interface PolicyRegistrationResponse {
	id: string;
	contract: 'ADESAO' | 'COMPULSORIO';
	days: number | null;
	inclusion_rule: 'IMEDIATO' | 'NUMERO_DIAS';
	max_age: number;
	name: string;
	payments: PolicyPaymentsResp;
	policy_rules: PolicyApRulesResp;
	positions: { id: string; name: string }[];
}

export interface PolicyRequest {
	application_rules: PolicyApRules;
	contract: 'ADESAO' | 'COMPULSORIO';
	days: number | null;
	dental_plan: boolean;
	health_plan: boolean;
	inclusion_rule: 'IMEDIATO' | 'NUMERO_DIAS';
	max_age: number;
	name: string;
	payments: PolicyPayments;
	position_ids: string[];
	positions_disconnect: string[];
}

export interface PolicyPayments {
	fifth_dep_type: '%' | 'R$';
	fifth_dep_value: number | null;
	first_dep_type: '%' | 'R$';
	first_dep_value: number | null;
	fourth_dep_type: '%' | 'R$';
	fourth_dep_value: number | null;
	owner_type: '%' | 'R$';
	owner_value: number;
	second_dep_type: '%' | 'R$';
	second_dep_value: number | null;
	sixth_dep_type: '%' | 'R$';
	sixth_dep_value: number | null;
	spouse_type: '%' | 'R$';
	spouse_value: number | null;
	third_dep_type: '%' | 'R$';
	third_dep_value: number | null;
}

export interface PolicyApRules {
	city: string | null;
	max_wage: number | null;
	min_wage: number | null;
	state: string | null;
}

export interface PolicyAdRules {
	days: number | null;
	inclusion_rule: 'IMEDIATO' | 'NUMERO_DIAS';
	max_age: number;
}

export const CONTRACT_MODEL = [
	{ label: 'Adesão', value: 'ADESAO' },
	{ label: 'Compulsório', value: 'COMPULSORIO' },
];

export const INCLUSION_RULES = [
	{ label: 'Imediato', value: 'IMEDIATO' },
	{ label: 'Número de dias', value: 'NUMERO_DIAS' },
];
